import { render } from "./Confirmation.vue?vue&type=template&id=19cdc4c8&ts=true"
import script from "./Confirmation.vue?vue&type=script&lang=ts"
export * from "./Confirmation.vue?vue&type=script&lang=ts"

import "./Confirmation.vue?vue&type=style&index=0&id=19cdc4c8&lang=scss"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__